module.exports = __webpack_public_path__ + "img/350c03a1a437418b90dee3b1dfb0789c.575941b5.png";